import { render, staticRenderFns } from "./copyright-aspedia.vue?vue&type=template&id=7516b85c&scoped=true"
import script from "./copyright-aspedia.vue?vue&type=script&lang=js"
export * from "./copyright-aspedia.vue?vue&type=script&lang=js"
import style0 from "./copyright-aspedia.vue?vue&type=style&index=0&id=7516b85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516b85c",
  null
  
)

export default component.exports